import { ThemeUIStyleObject } from "theme-ui"

export const googleMapStyles: ThemeUIStyleObject = {
  "div[role=button]:focus": {
    outline: 0,
    boxShadow: "none",
  },
  ".gm-style button": {
    display: "none !important",
  },
  ".gm-style-iw.gm-style-iw-c": {
    pr: "7px !important",
    pl: "7px !important",
    pt: "7px !important",
    pb: 3,
  },
  ".gm-style-iw-d": {
    overflow: "auto !important",
  },
  ".gm-style img": {
    maxWidth: "100%",
  },
}

export const googleMapContainerStyles: ThemeUIStyleObject = {
  borderStyle: "solid",
  borderWidth: ["9px", "17px"],
  borderColor: "white",
}

export const infoContentStyles: ThemeUIStyleObject = {
  width: "210px",
  maxWidth: "100%",
  pt: 0,
}

export const infoHeadingStyles: ThemeUIStyleObject = {
  fontSize: "paragraphSmall",
  color: "darkGray",
  mb: 2,
}

export const infoTextStyles: ThemeUIStyleObject = {
  fontSize: "smText",
  fontWeight: "300",
  mb: 2,
  "& p": {
    mb: 2,
  },
}

export const infoLinkStyles: ThemeUIStyleObject = {
  display: "block",
  fontSize: "smText",
  color: "gray",
  mb: 2,
  textDecoration: "underline",
  ":hover, :focus": {
    textDecoration: "underline",
    boxShadow: "none",
  },
}
